import React from 'react';

import { useIntl } from 'react-intl';
import styled from 'styled-components';

import LoadingAnimation from 'components/loading-animation';
import Picture from 'components/picture';
import { useFeatureLayout } from 'hooks/use-feature-layout';
import useGooglePass from 'state/mobile-pass/hooks/use-google-pay-pass';
import { WalletPassState } from 'state/mobile-pass/types';

const WalletErrorText = styled.span`
  font-size: 0.875rem;
`;

const WalletImageContainer = styled.div`
  width: 288px;
`;

const GooglePass: React.FC = () => {
  const { formatMessage } = useIntl();

  const { addGooglePass, googlePassState, shouldRenderGooglePass } = useGooglePass();

  const { featureLayout } = useFeatureLayout();

  const googlePayImage = featureLayout?.googlePayImage?.locale;

  if (!shouldRenderGooglePass) {
    return null;
  }

  switch (googlePassState) {
    case WalletPassState.LOADING:
      return <LoadingAnimation />;
    case WalletPassState.ERROR:
      return <WalletErrorText>{formatMessage({ id: 'errorSavingGooglePass' })}</WalletErrorText>;
    default:
      return (
        <WalletImageContainer onClick={addGooglePass}>
          {googlePayImage && (
            <Picture
              image={googlePayImage}
              alt={formatMessage({ id: 'addToGooglePayAlt' })}
              objectFitContain
            />
          )}
        </WalletImageContainer>
      );
  }
};

export default GooglePass;
